import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  colorSchemes: { light: true, dark: false },
  palette: {
    primary: {
      dark: '#3741af',
      main: '#4f5efa',
      light: '#727efb',
    },
    secondary: {
      dark: '#b29420',
      main: '#ffd42f',
      light: '#ffdc58',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(128, 128, 128, 0.3) transparent',
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'rgba(128, 128, 128, 0.3)',
          borderRadius: '4px',
          '&:hover': {
            background: 'rgba(128, 128, 128, 0.5)',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          boxShadow: '0px 0px 30px 0px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        cell: {
          '&:focus': {
            outline: 'none',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 6, // Set global border radius value
  },
});

const darkTheme = createTheme({
  colorSchemes: { light: false, dark: true },
  palette: {
    mode: 'dark',
    primary: {
      dark: '#5a67ff',
      main: '#4f5efa',
      light: '#727efb',
    },
    secondary: {
      dark: '#b29420',
      main: '#ffd42f',
      light: '#ffdc58',
    },
    text: {
      primary: '#C9CED8',
      secondary: '#8c99ad',
      disabled: 'rgba(130, 130, 130, 0.5)',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
  typography: {
    h1: { color: '#ECEEF1' },
    h2: { color: '#ECEEF1' },
    h3: { color: '#ECEEF1' },
    h4: { color: '#ECEEF1' },
    h5: { color: '#ECEEF1' },
    h6: { color: '#ECEEF1' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(128, 128, 128, 0.3) transparent',
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: 'rgba(128, 128, 128, 0.3)',
          borderRadius: '4px',
          '&:hover': {
            background: 'rgba(128, 128, 128, 0.5)',
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          boxShadow: '0px 0px 30px 0px rgba(0,0,0,0.5)',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        cell: {
          '&:focus': {
            outline: 'none',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
        filled: {
          color: '#bdbdbd',
          border: '1px solid rgba(158, 158, 158, 0.3)',
        },
        colorInfo: {
          backgroundColor: 'rgba(3, 155, 229, 0.15)',
          color: '#4fc3f7',
          border: '1px solid rgba(3, 155, 229, 0.3)',
          '& .MuiChip-icon': {
            color: '#4fc3f7',
          },
          '& .MuiChip-label': {
            color: '#4fc3f7',
          },
        },
        colorSuccess: {
          backgroundColor: 'rgba(76, 175, 80, 0.15)',
          color: '#81c784',
          border: '1px solid rgba(76, 175, 80, 0.3)',
          '& .MuiChip-icon': {
            color: '#81c784',
          },
          '& .MuiChip-label': {
            color: '#81c784',
          },
        },
        colorError: {
          backgroundColor: 'rgba(244, 67, 54, 0.15)',
          color: '#ef5350',
          border: '1px solid rgba(244, 67, 54, 0.3)',
          '& .MuiChip-icon': {
            color: '#ef5350',
          },
          '& .MuiChip-label': {
            color: '#ef5350',
          },
        },
        colorWarning: {
          backgroundColor: 'rgba(255, 152, 0, 0.15)',
          color: '#ffb74d',
          border: '1px solid rgba(255, 152, 0, 0.3)',
          '& .MuiChip-icon': {
            color: '#ffb74d',
          },
          '& .MuiChip-label': {
            color: '#ffb74d',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 6,
  },
});

export { lightTheme, darkTheme };
